<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2021-07-13 14:35:21
 * @LastEditors: xiawenlong
 * @LastEditTime: 2026-04-08 09:03:03
-->
<template>
  <div class="data-board">
    <div class="data-list">
      <div class="data-item" @click="handleBizOrderClick">
        <div class="icon">
          <img src="@/img/agriculture/data_icon_2.png" alt="" />
        </div>
        <div class="content">
          <div class="key">批发成交</div>
          <div class="value">
            <countTo
              :start-val="start.businessSalesAmount"
              :end-val="data.businessSalesAmount"
              separator=""
              :duration="countToDuration"
              :decimals="2"
            ></countTo>
            <span class="unit"> 万元</span>
          </div>
        </div>
      </div>
      <div class="data-item" @click="handleUserOrderClick">
        <div class="icon">
          <img src="@/img/agriculture/data_icon_3.png" alt="" />
        </div>
        <div class="content">
          <div class="key">零售成交</div>
          <div class="value">
            <countTo
              :start-val="start.retailSalesAmount"
              :end-val="data.retailSalesAmount"
              separator=""
              :duration="countToDuration"
              :decimals="2"
            ></countTo>
            <span class="unit"> 万元</span>
          </div>
        </div>
      </div>
      <div class="data-item" @click="handleGroupOrderClick">
        <div class="icon">
          <img src="@/img/agriculture/data_icon_1.png" alt="" />
        </div>
        <div class="content">
          <div class="key">校园餐销售额</div>
          <div class="value">
            <countTo
              :start-val="start.ckPutTotalPriceTotal"
              :end-val="data.ckPutTotalPriceTotal"
              separator=""
              :duration="countToDuration"
              :decimals="2"
            ></countTo>
            <span class="unit"> 万元</span>
          </div>
        </div>
      </div>
      <div class="data-item" @click="handleAreaCompanyOrderClick">
        <div class="icon">
          <img src="@/img/agriculture/data_icon_4.png" alt="" />
        </div>
        <div class="content">
          <div class="key" style="margin-left:-9px">新型农村集体经济组织</div>
          <div class="value">
            <countTo
              :start-val="start.ruralEconomyAmount"
              :end-val="data.ruralEconomyAmount"
              separator=""
              :duration="countToDuration"
              :decimals="2"
            ></countTo>
            <span class="unit"> 万元</span>
          </div>
        </div>
      </div>
      <div class="data-item" @click="handleProductClick">
        <div class="icon">
          <img src="@/img/agriculture/data_icon_5.png" alt="" />
        </div>
        <div class="content">
          <div class="key">商品数量</div>
          <div class="value">
            <countTo
              :start-val="start.productCount"
              :end-val="data.productCount"
              separator=""
              :duration="countToDuration"
            ></countTo>
          </div>
        </div>
      </div>
      <div class="data-item" @click="handleSupplierClick">
        <div class="icon">
          <img src="@/img/agriculture/data_icon_6.png" alt="" />
        </div>
        <div class="content">
          <div class="key">供应商数量</div>
          <div class="value">
            <countTo
              :start-val="start.supplierCount"
              :end-val="data.supplierCount"
              separator=""
              :duration="countToDuration"
            ></countTo>
          </div>
        </div>
      </div>
      <div class="data-item" @click="handleBizCusClick">
        <div class="icon">
          <img src="@/img/agriculture/data_icon_7.png" alt="" />
        </div>
        <div class="content">
          <div class="key">企业客户数量</div>
          <div class="value">
            <countTo
              :start-val="start.businessCustomerCount"
              :end-val="data.businessCustomerCount"
              separator=""
              :duration="countToDuration"
            ></countTo>
          </div>
        </div>
      </div>
      <div class="data-item" @click="handleUserCusClick">
        <div class="icon">
          <img src="@/img/agriculture/data_icon_8.png" alt="" />
        </div>
        <div class="content">
          <div class="key">个人客户数量</div>
          <div class="value">
            <countTo
              :start-val="start.personalCustomerCount"
              :end-val="data.personalCustomerCount"
              separator=""
              :duration="countToDuration"
            ></countTo>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import countTo from 'vue-count-to'
export default {
  components: { countTo },
  data() {
    return {
      type: 3,
      data: {
        ckPutTotalPriceTotal: 0,
        businessSalesAmount: 0,
        retailSalesAmount: 0,
        ruralEconomyAmount: 0,
        productCount: 0,
        supplierCount: 0,
        businessCustomerCount: 0,
        personalCustomerCount: 0,
      },
      start: {
        ckPutTotalPriceTotal: 0,
        businessSalesAmount: 0,
        retailSalesAmount: 0,
        ruralEconomyAmount: 0,
        productCount: 0,
        supplierCount: 0,
        businessCustomerCount: 0,
        personalCustomerCount: 0,
      },
      countToDuration: 3000,
    }
  },
  methods: {
    async initData(res) {
      console.log(`output->res.data`, res.data)
      for (const key in this.data) {
        if (Object.hasOwnProperty.call(this.data, key)) {
          const count = this.data[key]
          if (count != res.data[key]) {
            const index = Object.keys(this.data).indexOf(key) // 获取属性的数字索引
            document.querySelectorAll('.data-item')[index].className = 'data-item highlight'
            setTimeout(() => {
              document.querySelectorAll('.data-item')[index].className = 'data-item'
            }, 1000)
          }
        }
      }
      const {
        ckPutTotalPriceTotal,
        businessSalesAmount,
        retailSalesAmount,
        ruralEconomyAmount,
        productCount,
        supplierCount,
        businessCustomerCount,
        personalCustomerCount,
      } = res.data
      this.data = {
        ckPutTotalPriceTotal: ckPutTotalPriceTotal - 0,
        businessSalesAmount: businessSalesAmount - 0,
        retailSalesAmount: retailSalesAmount - 0,
        ruralEconomyAmount: ruralEconomyAmount - 0,
        productCount: productCount - 0,
        supplierCount: supplierCount - 0,
        businessCustomerCount: businessCustomerCount - 0,
        personalCustomerCount: personalCustomerCount - 0,
      }
    },
    handleClick(index) {
      this.$emit('click', index)
    },
    handleProductClick() {
      this.$emit('product-click')
    },
    handleSupplierClick() {
      this.$emit('supplier-click')
    },
    handleBizCusClick() {
      this.$emit('biz-cus-click')
    },
    handleUserCusClick() {
      this.$emit('user-cus-click')
    },
    handleBizOrderClick() {
      this.$emit('biz-order-click')
    },
    handleUserOrderClick() {
      this.$emit('user-order-click')
    },
    handleGroupOrderClick() {
      this.$emit('group-order-click')
    },
    handleAreaCompanyOrderClick() {
      this.$emit('area-company-order-click')
    },
  },
}
</script>
<style lang="scss" scoped>
.data-board {
  position: relative;
  z-index: 8888;
  width: 100%;
}

.data-list {
  display: flex;
  flex-wrap: wrap;

  .data-item {
    padding-left: 14px;
    display: flex;
    position: relative;
    width: 373px;
    height: 108px;
    margin-right: 28px;
    box-sizing: border-box;
    margin-bottom: 14px;
    transition: transform 0.5s ease, color 0.5s ease;
    background: rgba(1, 12, 104, 0.4);
    border-radius: 2px 2px 2px 2px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 6px;
      height: 108px;
      background: #0d3a93;
      border-radius: 2px 2px 2px 2px;
    }

    &:nth-of-type(4n) {
      margin-right: 0;
    }

    .icon {
      width: 93px;
      height: 108px;
      background: #0d3a93;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .content {
      padding-top: 19px;
      overflow: hidden;
      padding-left: 20px;

      .key {
        line-height: 25px;
        font-weight: 400;
        font-size: 25px;
        color: #fff;
        white-space: nowrap;
        margin-bottom: 16px;
      }

      .value {
        line-height: 27px;
        font-weight: 800;
        font-size: 35px;
        color: #fff;

        .unit {
          font-weight: 400;
          font-size: 25px;
        }
      }
    }
  }
}
</style>
